var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-6949.92,-1777.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.503937,0,0,0.571731,5702.11,846.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Two-tools",
    serifId: "Two tools",
    transform: "matrix(0.102975,0,0,0.0907646,2221.36,1347.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hammer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2801.16,3221.17L2801,3221C2801,3221 2793,3213.09 2793,3208C2793,3202.17 2800.78,3197.44 2801,3186C2801.22,3174.56 2797.93,3163.59 2781,3148C2764.08,3132.41 2745.75,3127.9 2739,3125C2728.15,3120.33 2709.05,3117.26 2704.45,3116.79C2699.84,3116.32 2720.3,3108.42 2737,3108C2753.7,3107.58 2802.07,3105.88 2878,3179C2907.03,3207.15 2913.83,3227.44 2915,3235C2916.17,3242.56 2915.99,3246.59 2917,3250C2918.01,3253.41 2928,3267 2928,3267L2928.11,3267.09L2933.86,3261.34C2940.18,3255.02 2950.44,3255.02 2956.76,3261.34C2963.08,3267.66 2963.08,3277.92 2956.76,3284.24L2921.24,3319.76C2914.92,3326.08 2904.66,3326.08 2898.34,3319.76C2892.02,3313.44 2892.02,3303.18 2898.34,3296.86L2902.02,3293.18C2897.35,3289.3 2877.51,3272.84 2875,3271C2872.15,3268.91 2866.01,3264.75 2863,3265C2859.99,3265.25 2856.23,3267.01 2853.39,3267.01C2850.55,3267.01 2846.21,3265.74 2845,3265C2843.79,3264.26 2841.04,3262.67 2839,3261C2836.96,3259.33 2834.7,3256.61 2834,3256C2833.96,3255.97 2833.82,3255.82 2833.59,3255.59L2693.43,3395.75L2660,3362.33L2801.16,3221.17Z",
    style: {
      fill: "rgb(109,109,109)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.522896,0.522896,-0.986429,0.986429,4677.6,-1314.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2615.74,3410.88C2615.74,3406.8 2609.5,3403.49 2601.8,3403.49L2547.24,3404C2539.55,3404 2533.3,3407.31 2533.3,3411.39L2518,3565.61C2518,3569.69 2524.25,3573 2531.94,3573L2618.06,3573C2625.75,3573 2632,3569.69 2632,3565.61L2615.74,3410.88Z",
    style: {
      fill: "rgb(109,109,109)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Wrench"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2552.53,3147.04C2545.48,3140 2543.37,3129.41 2547.17,3120.21C2550.98,3111 2559.96,3104.99 2569.92,3104.99C2569.95,3105 2569.97,3105 2570,3105C2621.33,3105 2663,3146.67 2663,3198C2663,3207.82 2661.47,3217.28 2658.65,3226.17L2714.51,3282.03L2654.53,3342.01L2598.92,3286.41C2589.82,3289.39 2580.1,3291 2570,3291C2518.67,3291 2477,3249.33 2477,3198C2477,3197.98 2477,3197.96 2477,3197.95C2477.01,3187.82 2483.12,3178.69 2492.48,3174.82C2501.84,3170.95 2512.6,3173.1 2519.76,3180.26C2536.47,3196.96 2553.99,3214.48 2553.99,3214.48C2563.09,3223.58 2577.87,3223.58 2586.98,3214.48C2596.08,3205.37 2596.08,3190.59 2586.98,3181.49C2586.98,3181.49 2569.29,3163.8 2552.53,3147.04Z",
    style: {
      fill: "rgb(109,109,109)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-6.12323e-17,-1,-1,6.12323e-17,6056.52,6056.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2552.53,3147.04C2545.48,3140 2543.37,3129.41 2547.17,3120.21C2550.98,3111 2559.96,3104.99 2569.92,3104.99C2569.95,3105 2569.97,3105 2570,3105C2621.33,3105 2663,3146.67 2663,3198C2663,3207.82 2661.47,3217.28 2658.65,3226.17L2714.51,3282.03L2654.53,3342.01L2598.92,3286.41C2589.82,3289.39 2580.1,3291 2570,3291C2518.67,3291 2477,3249.33 2477,3198C2477,3197.98 2477,3197.96 2477,3197.95C2477.01,3187.82 2483.12,3178.69 2492.48,3174.82C2501.84,3170.95 2512.6,3173.1 2519.76,3180.26C2536.47,3196.96 2553.99,3214.48 2553.99,3214.48C2563.09,3223.58 2577.87,3223.58 2586.98,3214.48C2596.08,3205.37 2596.08,3190.59 2586.98,3181.49C2586.98,3181.49 2569.29,3163.8 2552.53,3147.04Z",
    style: {
      fill: "rgb(109,109,109)"
    }
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.449cae82eee26d3ebf787208ab169fc9.svg";
export { ForwardRef as ReactComponent };